/**
 * @category  sc
 * @package   Product_Test
 * @author    Ali Eltahan <info@alieltahan.com>
 */

export const BOOK = 'Book';
export const DVD = 'DVD';
export const FURNITURE = 'Furniture';